import { render, staticRenderFns } from "./InvoicePaymentTable.vue?vue&type=template&id=88eb46b0&scoped=true"
import script from "./InvoicePaymentTable.vue?vue&type=script&lang=js"
export * from "./InvoicePaymentTable.vue?vue&type=script&lang=js"
import style0 from "./InvoicePaymentTable.vue?vue&type=style&index=0&id=88eb46b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88eb46b0",
  null
  
)

export default component.exports